import React from "react";
import clsx from "clsx";
import iconAvatar from "assets/IconAvatar.svg?url";

const Avatar = (props) => (
	<div
		className={clsx(
			"Avatar_container",
			props.overrideAvatarClass || "Avatar_icon",
			props.overrideColorClass || "Avatar_containerColorDefault"
		)}
		style={{ backgroundColor: props.color || "#cdcdcd" }}
	>
		{props.label ? props.label : <img className="Avatar_containerImage" src={iconAvatar} alt="" />}
	</div>
);

export default Avatar;
